import { IFrameInitMessage } from '../iframe';
import {
  AcademicRegistrationStartParams,
  AssetStatus,
  CheckoutEnvironment,
  CheckoutSession,
  CheckoutStartParams,
  GeneralStartParams,
  LinkedAccount
} from './checkout-drop-in-api';

export type CheckoutFrameCommunicationMessage =
  | InitMessage
  | LinkAccountMessage
  | NotifySignedInChangeMessage
  | NotifyAssetStatusChangeMessage
  | NotifyCheckoutSessionChangeMessage
  | RedirectMessage
  | RegisterForAssetStatusChangeMessage
  | RegisterForCheckoutSessionChangeMessage
  | SetFrameVisibilityConfirmMessage
  | SetFrameVisibilityMessage
  | ShowErrorMessage
  | SignInMessage
  | SignOutMessage
  | StartAcademicRegistrationMessage
  | StartCheckoutMessage;

export interface SetFrameVisibilityConfirmMessage {
  source: 'checkout-drop-in';
  action: 'setFrameVisibilityConfirm';
  visible: boolean;
}

export interface SetFrameVisibilityMessage {
  source: 'web-checkout' | 'web-checkout-demo';
  action: 'setFrameVisibility';
  visible: boolean;
  clearAutostartParam: boolean;
}

export interface RedirectMessage {
  source: 'web-checkout';
  action: 'redirect';
  redirectUrl: string;
}

export interface InitMessage extends IFrameInitMessage {
  source: 'checkout-drop-in';
}

export interface LinkAccountMessage {
  source: 'checkout-drop-in';
  action: 'linkAccount';
  linkedAccount?: LinkedAccount | null;
}

export interface NotifySignedInChangeMessage {
  source: 'web-checkout';
  action: 'notifySignedInChange';
  signedIn: boolean;
}

export interface NotifyAssetStatusChangeMessage {
  source: 'web-checkout';
  action: 'notifyAssetStatusChange';
  productId: string;
  environment: CheckoutEnvironment;
  assetStatus: AssetStatus;
}

export interface NotifyCheckoutSessionChangeMessage {
  source: 'web-checkout';
  action: 'notifyCheckoutSessionChange';
  checkoutSession: CheckoutSession | null;
}

export interface RegisterForAssetStatusChangeMessage {
  source: 'checkout-drop-in';
  action: 'registerForAssetStatusChange';
  productId: string;
  environment: CheckoutEnvironment;
}

export interface RegisterForCheckoutSessionChangeMessage {
  source: 'checkout-drop-in';
  action: 'registerForCheckoutSessionChange';
  vendorId: string;
}

export interface ShowErrorMessage {
  source: 'checkout-drop-in';
  action: 'showError';
  errorType: string;
}

export interface SignInMessage {
  action: 'signIn';
  source: 'checkout-drop-in';
  vendorId: string;
  params?: GeneralStartParams | null;
}

export interface SignOutMessage {
  source: 'checkout-drop-in';
  action: 'signOut';
}

export interface StartAcademicRegistrationMessage {
  source: 'checkout-drop-in';
  action: 'startAcademicRegistration';
  params?: AcademicRegistrationStartParams | null;
}

export interface StartCheckoutMessage {
  source: 'checkout-drop-in';
  action: 'startCheckout';
  productId: string;
  params?: CheckoutStartParams | null;
}
